<template>
<div>
  <reservation 
    v-if="showPage == 'reservation'" 
    :fts="fts" 
    :lts="lts" 
    :loc="loc" 
    :closed="closed" 
    :res_token="res_token" />
  <reservation-modify 
    v-if="showPage == 'modify'"
    :res_token="res_token" />
</div>
</template>

<script>

import reservation from '@comp/reservation'
import reservationModify from '@comp/reservationModify'

export default {
  components: {
    reservation,
    reservationModify
  },
  data() {
    return ({
    })
  },
  props: [ 'fts','lts','loc','closed', 'res_token' ],
  computed: {
    showPage() {
      return this.$store.state.availability.showPage
    },
    resInfoLoaded() {

    },
    token() {

    },
    userInfoLoaded() {

    }
  },
  methods: {

  },
  mounted() {
    if ( this.res_token ) {
      this.$store.commit( "availability/SET_SHOW_PAGE", "modify")
      this.$store.dispatch( "userInfo/getReservation", { res_token: this.res_token } )
    } else {
      this.$store.commit( "availability/SET_SHOW_PAGE", "reservation")

    }
  }
}
</script>

<style lang="scss" scoped>

</style>